export enum FieldStatus {
  Protected = 1,
  Unprotected = 2,
  Edited = 3,
}
